function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { buildService } from '../../services/service';
import serviceMethods from '../../services/service_methods';
import { useCallback } from 'react';
const api = buildService('/folder_files', {
  only: ['create']
});
const useGetPresignedUrl = () => {
  return useCallback(async (fileName, contentType) => {
    const response = await fetch('/api/folder_files/presigned_url', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        file_name: fileName,
        content_type: contentType
      })
    });
    if (!response.ok) {
      throw new Error('Failed to get presigned URL');
    }
    const res = response.json();
    return res;
  }, []);
};
const useCreateFolderFile = _ref => {
  let {
    setLoading,
    onSuccess,
    onError
  } = _ref;
  return serviceMethods.useCreate({
    callback: useCallback(async function (folderFileData) {
      let cloudFileRecordData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return await api.create(_objectSpread({
        folder_file: folderFileData
      }, cloudFileRecordData));
    }, []),
    setLoading,
    onSuccess,
    onError
  });
};
const fileUploadService = {
  useGetPresignedUrl,
  useCreateFolderFile
};
export default fileUploadService;